// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__15sj1","footer":"ModalInfo_footer__1Wlqo"};